// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__gzXP2","emails":"CreateEditClinics_emails__3T1_a","emailTagLabel":"CreateEditClinics_emailTagLabel__2kqm7"};